module.exports = __webpack_public_path__ + "media/images/trash-b57b747a.svg";